// actions
import {
  GET_TRUST,
  TRUST_HOURLY,
  TRUST_DAILY,
  TRUST_COMMENT_DAILY,
  TRUST_PERIOD,
  UPDATE_CHART,
  SET_PERIOD,
  SET_PENDING,
  SET_METHOD,
  SET_PERIOD_NAME,
  TO_START_CHART,
  SWITCH_ZERO,
  SET_ERROR,
  SET_EMPTY,
  SET_COMMON_GLOBAL_PERIOD, FIRST_TRUST_HOURLY, SET_ALL_EMPTY
} from "../../store/actions/analytics";

import { getTrustHourlyApi, getTrustDailyApi, getTrustCommentDailyApi } from "../../api/stats";

// libraries
import moment from "moment";
import { cloneDeep } from "lodash/lang";

const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

// functions
const getStartDate = () => {
  const endDate = new Date();
  const startDate = new Date();

  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);

  return [moment(startDate).format(DATE_FORMAT), moment(endDate).format(DATE_FORMAT)];
};

const defaultMethods = {
  "Statistic": TRUST_HOURLY,
  "PublicationsBySource": TRUST_HOURLY,
  "TonalPost": TRUST_HOURLY,
  "PublicationsBySourceAndGsm": TRUST_HOURLY,
  "DynamicBySource": TRUST_HOURLY,
  "DynamicBySourceAndGsm": TRUST_HOURLY,
  "TonalComment": TRUST_COMMENT_DAILY,
};

// config
import sourceShortcuts from "../../config/sourceShortcuts";

// store
const state = {
  commonGlobalPeriod: getStartDate(),
  trust: {
    Statistic: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.Statistic,
      request: {
        pending: false,
        error: false
      }
    },
    PublicationsBySource: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.PublicationsBySource,
      zeroData: false,
      request: {
        pending: false,
        error: false
      }
    },
    TonalPost: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.TonalPost,
      request: {
        pending: false,
        error: false
      }
    },
    PublicationsBySourceAndGsm: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.PublicationsBySourceAndGsm,
      zeroData: false,
      request: {
        pending: false,
        error: false
      }
    },
    DynamicBySource: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.DynamicBySource,
      request: {
        pending: false,
        error: false
      }
    },
    DynamicBySourceAndGsm: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.DynamicBySourceAndGsm,
      request: {
        pending: false,
        error: false
      }
    },
    TonalComment: {
      data: {},
      period: getStartDate(),
      dataEmpty: false,
      periodName: null,
      method: defaultMethods.TonalComment,
      request: {
        pending: false,
        error: false
      }
    }
  }
};

const getters = {
  chartMethod: state => chart => {
    return state.trust[chart].method;
  },
  getZeroData: state => chart => {
    return state.trust[chart].zeroData;
  },
  chartData: state => chart => {
    return state.trust[chart].data;
  },
  isLoaded: state => chart => {
    return Object.keys(state.trust[chart].data).length > 0;
  },
  pending: state => chart => {
    return state.trust[chart].request.pending;
  },
  periodName: state => (chart, i18n) => {
    let period = state.trust[chart].periodName;
    if (!period) {
      return i18n.t('feed.analytics.statistics.store.period.today');
    }
    return period;
  },
  getPeriod: state => chart => {
    return state.trust[chart].period;
  },
  dataEmpty: state => chart => {
    return state.trust[chart].dataEmpty;
  },
  getGlobalCommonPeriod: state => state.commonGlobalPeriod
};

const actions = {
  [SWITCH_ZERO]: ({ state, commit, dispatch }, payload) => {
    commit(SWITCH_ZERO, payload);
  },
  [SET_METHOD]: ({ state, commit, dispatch }, payload) => {
    commit(SET_METHOD, payload);
  },
  [SET_PERIOD_NAME]: ({ state, commit, dispatch }, payload) => {
    commit(SET_PERIOD_NAME, payload);
  },
  [SET_PERIOD]: ({ state, commit, dispatch }, payload) => {
    commit(SET_PERIOD, payload);
  },
  [GET_TRUST]: ({ state, commit, dispatch }, payload) => {
    const { chart } = payload;

    commit(SET_ERROR, {chart, error: false});
    commit(SET_PENDING, {chart, pending: true});

    dispatch(state.trust[chart].method, payload);
  },
  [TRUST_HOURLY]: ({ state, commit }, payload) => {
    const { chart, thread } = payload;

    console.log('TRUST_HOURLY =>', state.trust[chart])

    const params = {
      thread_id: parseInt(thread),
      from: state.trust[chart].period[0],
      to: state.trust[chart].period[1]
    };

    commit(SET_EMPTY, { empty: false, chart });

    getTrustHourlyApi(params)
      .then(resp => {
        console.log('TRUST_HOURLY resp.data', resp.data)
        commit(SET_PENDING, {chart, pending: false});

        if (!Array.isArray(resp.data)) {
          commit(TRUST_HOURLY, { data: resp.data, chart });
        } else {
          commit(SET_EMPTY, { empty: true, chart });
        }

      })
      .catch(() => {
        commit(SET_PENDING, {chart, pending: true});
        commit(SET_ERROR, {chart, error: false});
      });

  },
  [FIRST_TRUST_HOURLY]: ({ state, commit }, payload) => {
    const { thread } = payload;
    const period = getStartDate()
    const params = {
      thread_id: parseInt(thread),
      from: period[0],
      to: period[1]
    };

    const keys = Object.keys(state.trust)
    keys.forEach((chart) => {
      if (chart !== "TonalComment") {
        commit(SET_ERROR, {chart, error: false});
        commit(SET_PENDING, {chart, pending: true});
      }
    })

    commit(SET_ALL_EMPTY, { empty: false });

    
    getTrustHourlyApi(params)
      .then(resp => {
        console.log('FIRST_TRUST_HOURLY')
        keys.forEach((chart) => {
          console.log('FIRST_TRUST_HOURLY', state.trust[chart].data)
          if (chart !== "TonalComment") {
            commit(SET_PENDING, {chart, pending: false});

            if (!Array.isArray(resp.data)) {
              commit(TRUST_HOURLY, { data: resp.data, chart });
            } else {
              commit(SET_EMPTY, { empty: true, chart });
            }
          }
        })
      })
      .catch(() => {
        keys.forEach((chart) => {
          if (chart !== "TonalComment") {
            commit(SET_PENDING, {chart, pending: true});
            commit(SET_ERROR, {chart, error: false});
          }
        })
      });
  },
  [TRUST_COMMENT_DAILY]: ({ commit }, payload) => {
    const { chart, thread } = payload;

    const params = {
      thread_id: parseInt(thread),
      from: state.trust[chart].period[0],
      to: state.trust[chart].period[1]
    };

    commit(SET_EMPTY, { empty: false, chart });

    getTrustCommentDailyApi(params)
      .then(resp => {
        commit(SET_PENDING, {chart, pending: false});

        if (!Array.isArray(resp.data)) {
          commit(TRUST_COMMENT_DAILY, { data: resp.data, chart });
        } else {
          commit(SET_EMPTY, { empty: true, chart });
        }

      })
      .catch(() => {
        commit(SET_PENDING, {chart, pending: true});
        commit(SET_ERROR, {chart, error: false});
      });

  },
  [TRUST_DAILY]: ({ commit }, payload) => {
    const { chart, thread } = payload;

    const params = {
      thread_id: parseInt(thread),
      from: state.trust[chart].period[0],
      to: state.trust[chart].period[1]
    };

    commit(SET_EMPTY, { empty: false, chart });

    getTrustDailyApi(params)
      .then(resp => {
        commit(SET_PENDING, {chart, pending: false});

        if (!Array.isArray(resp.data)) {
          commit(TRUST_DAILY, { data: resp.data, chart });
        } else {
          commit(SET_EMPTY, { empty: true, chart });
        }

      })
      .catch(() => {
        commit(SET_PENDING, {chart, pending: true});
        commit(SET_ERROR, {chart, error: false});
      });
  },
  [TRUST_PERIOD]: ({ commit }, payload) => {
    const { chart, thread } = payload;

    const params = {
      thread_id: parseInt(thread)
    };

    commit(SET_EMPTY, { empty: false, chart });

    getTrustDailyApi(params).then(resp => {
      commit(SET_PENDING, {chart, pending: false});

      if (!Array.isArray(resp.data)) {
        commit(TRUST_PERIOD, { data: resp.data, chart });
      } else {
        commit(SET_EMPTY, { empty: true, chart });
      }

    })
      .catch(() => {
        commit(SET_PENDING, {chart, pending: true});
        commit(SET_ERROR, {chart, error: false});
      });
  },
  [UPDATE_CHART]: ({ commit }, payload) => {
    commit(UPDATE_CHART, payload);
    return Promise.resolve();
  },
  [TO_START_CHART]: ({ commit }, payload) => {
    commit(TO_START_CHART, payload);
  },
  [SET_COMMON_GLOBAL_PERIOD]: ({ state, commit, dispatch }, payload) => {
    commit(SET_COMMON_GLOBAL_PERIOD, payload);
    const stateEntries = Object.entries(state.trust);

    stateEntries.forEach(item => {
      commit(SET_PERIOD, {chart: item[0], period: payload.period});
      commit(SET_PERIOD_NAME, {chart: item[0], title: payload.title});
      commit(SET_METHOD, {chart: item[0], method: payload.method});
      commit(SET_PENDING, {chart: item[0], pending: true});

      if (item[0] === 'TonalComment') {
        dispatch(TRUST_COMMENT_DAILY, {chart: item[0], thread: payload.thread});
      } else {
        dispatch(GET_TRUST, {chart: item[0], thread: payload.thread});
      }

    });

  },
};

const mutations = {
  [SET_COMMON_GLOBAL_PERIOD]: (state, payload) => {
    const {period} = payload;
    state.commonGlobalPeriod = period;
  },
  [SET_EMPTY]: (state, payload) => {
    const {empty, chart} = payload;
    state.trust[chart].dataEmpty = empty;
  },
  [SET_ALL_EMPTY]: (state, payload) => {
    const keys = Object.keys(state.trust)
    keys.forEach((key) => {
      if (key !== "TonalComment") {
        state.trust[key].dataEmpty = payload.empty;
      }
    })
  },
  [SWITCH_ZERO]: (state, payload) => {
    const {chart, isZero} = payload;
    state.trust[chart].zeroData = isZero;
  },
  [SET_METHOD]: (state, payload) => {
    const {chart, method} = payload;
    state.trust[chart].method = method;
  },
  [SET_PERIOD_NAME]: (state, payload) => {
    const {chart, title} = payload;
    state.trust[chart].periodName = title;
  },
  [SET_PERIOD]: (state, payload) => {
    const {chart, period} = payload;
    state.trust[chart].period = period;
  },
  [SET_PENDING]: (state, {chart, pending}) => {
    state.trust[chart].request.pending = pending;
  },
  [SET_ERROR]: (state, {chart, error}) => {
    state.trust[chart].request.error = error;
  },
  [TRUST_HOURLY]: (state, {data, chart}) => {
    console.log('TRUST_HOURLY mutation', data)
    state.trust[chart].data = data;
  },
  [TRUST_DAILY]: (state, {data, chart}) => {
    state.trust[chart].data = data;
  },
  [TRUST_COMMENT_DAILY]: (state, {data, chart}) => {
    state.trust[chart].data = data;
  },
  [TRUST_PERIOD]: (state, {data, chart}) => {
    state.trust[chart].data = data;
  },
  [UPDATE_CHART]: (state, { chart, source, tonal, value, index }) => {
    let data = cloneDeep(state.trust[chart].data);
    const sources = Object.keys(sourceShortcuts);

    data[source][tonal][index][1] = value;
    data[source].total[index][1] = data[source].netural[index][1] + data[source].negative[index][1] + data[source].positive[index][1];

    let sum = 0;

    sources.forEach(source => {
      if(data[source]) {
        sum += data[source][tonal][index][1];
      }
    });

    data.total[tonal][index][1] = sum;
    data.total.total[index][1] = data.total.netural[index][1] + data.total.negative[index][1] + data.total.positive[index][1];

    state.trust[chart].data = cloneDeep(data);
    data = null;
  },
  [TO_START_CHART]: (state, {chart}) => {
    state.trust[chart].period = getStartDate();
    state.trust[chart].periodName = "Сегодня";
    state.trust[chart].data = {};

    let trust = Object.keys(state.trust);
    trust.forEach(chart => {
      state.trust[chart].method = defaultMethods[chart];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
